import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ModalDismissReasons, NgbActiveModal, NgbCalendar, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { BaseService } from 'projects/Autofacets-Core/src/app/services/base.service';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { Observable, Subscription } from 'rxjs';
import { MechanicLeavesViewModel } from '../../../../business-entities/mechanic-opening-hours-view-model';
import { MechanicService } from '../../../../business-services/mechanic.service';
import * as Enums from './../../../../../../../Autofacets-Core/src/app/utils/enums';
import { DealerWorkingHoursBusinessService } from '../../../../business-services/dealer-working-hours.service';
import { DealerOpeningHoursViewModel } from '../../../../business-entities/dealer-opening-hours-view-model';

const weekDays: { id: number, name: string ,isSelected:boolean}[] = [
  { id: 0, name: 'SUN' ,isSelected:false},
  { id: 1, name: 'MON' ,isSelected:false},
  { id: 2, name: 'TUE' ,isSelected:false},
  { id: 3, name: 'WED' ,isSelected:false},
  { id: 4, name: 'THU' ,isSelected:false},
  { id: 5, name: 'FRI',isSelected:false },
  { id: 6, name: 'SAT' ,isSelected:false}
]
@Component({
  selector: 'app-edit-leaves-mechanic',
  templateUrl: './edit-leaves-mechanic.component.html',
  styleUrls: ['./edit-leaves-mechanic.component.css']
})
export class EditLeavesMechanicComponent implements OnInit {
  popupCloseResult = false;
  id: number;
  response: any;
  total$: Observable<number>;
  paginationSub: Subscription;
  dealerId: string;
  mechanicLeavesDetails: boolean;
  leaveId: number;
  mechanicLeaveTypesList = [];
  mechanicLeaves: MechanicLeavesViewModel =
    {
      id: null,
      mechanicId: null,
      startDate: null,
      endDate: null,
      startDateTime: null,
      endDateTime: null,
      option:1,
      leaveType:1,
      remark:null,
      selectedDays:'',
      absenceHour:'',
      recurring:1,
      mechanicLeaveRecurringId:null,
      multiDateList:[],
      dmsLeaveId: ''
    };
  startDate: NgbDateStruct;
  endDate: NgbDateStruct;
  leavesList: MechanicLeavesViewModel[];
  editMechanicLeave: boolean;
  addMechanicLeave: boolean;
  today = this.calendar.getToday();
  weekDays:any;
  dealerWorkingHours: DealerOpeningHoursViewModel[];
  recurringDefaultStartTime:string;
  recurringDefaultEndTime:string;
  isLeaveTypeHidden = false;
  customLeaveType = [];
  _clientName: string;

  constructor(private service: MechanicService,
    public pService: CustomPaggerService,
    private secureStorage: SecureStorage, private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private modalService: NgbModal,
    private datePipe: DatePipe,
    private translate: TranslateService,
    private baseService: BaseService,
    private calendar: NgbCalendar,
    private cookieservice: CookieService,
    private dealerWorkingHoursBusinessService : DealerWorkingHoursBusinessService,
    private globalSetting: GlobalSetting, private activeModal: NgbActiveModal) {
    this.pService.pageSize = 10;
    this.pService.searchby = ['name', 'dealerName', 'employeeNo'];
    this.pService.searchTerm = '';
    this.weekDays= weekDays;
  }


  onDaySelected(item:any,event:any)
  {
    let days = [];
    days = this.mechanicLeaves.selectedDays?.split(',');
    if(days.indexOf('') > -1){
      days.splice(days.indexOf(''),1);
    }
    if(item.isSelected){
      if(!(days.includes(item.id.toString()))){
        days.push(item.id.toString());
      }
    }
    else{
      if(days.includes(item.id.toString())){
        days.splice(days.indexOf(item.id.toString()),1)
      }
    }
    this.mechanicLeaves.selectedDays = days.join(',');
  }

  ngOnInit(): void {
    this._clientName = localStorage.getItem('Theme');
    if (this._clientName === 'mg') {
      this.isLeaveTypeHidden = true;
      this.customLeaveType = [
        {
          id: 'Sykemelding',
          value: 1,
          name: 'Sykemelding'
        },
        {
          id: 'Egenmelding',
          value: 2,
          name: 'Egenmelding'
        },
        {
          id: 'Kurs/trening',
          value: 3,
          name: 'Kurs/trening'
        },
        {
          id: 'Ferie',
          value: 4,
          name: 'Ferie'
        },
        {
          id: 'Permisjon',
          value: 5,
          name: 'Permisjon'
        }
      ]
    }
    this.id = this.service.mechanicId;
    this.dealerId = this.service.dealerId;
    this.mechanicLeavesDetails = true;
    this.GetMechanicLeavesList(this.id);
    this.GetDefaultShift();
    this.GetMechanicLeaveTypes();
  }

  async GetDefaultShift(){
    await this.dealerWorkingHoursBusinessService.getDealerWorkingHoursDetails(this.dealerId,1).then((response)=>{
      this.dealerWorkingHours = response;
      let shift = this.dealerWorkingHours?.find(x => x.dayNumber == Enums.WeekDays.Monday);
      this.recurringDefaultStartTime =this.datePipe.transform(shift?.openingTimeHrs,'HH:mm') ;
      this.recurringDefaultEndTime = this.datePipe.transform(shift?.closingTimeHrs,'HH:mm');
    });
  }

  GetMechanicLeavesList(id: number) {
    let internalErrorMessage = this.translate.instant("lblGetLeaveInternalError");
    let invalidIdErrorMessage = this.translate.instant("lblInvalidMechanicId");
    this.spinner.show();
    this.service.GetMechanicLeavesList(id).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        this.pService.dataSource = response.responseObject;
        this.paginationSub = this.pService.dealers$.subscribe((result: any) => {
          this.leavesList = this.MechanicLeavesDataMapper(result);
        });
        this.total$ = this.pService.total$;
        this.spinner.hide();
      }
      else if (response.responseCode === Enums.ErrorCodes.InterrnalError) {
        this.spinner.hide();
        this.toaster.error(internalErrorMessage);
      }
      else if (response.responseCode === Enums.ErrorCodes.InvalidMechanicId) {
        this.spinner.hide();
        this.toaster.warning(invalidIdErrorMessage);
      }
      this.spinner.hide();
    });
  }

  AddMechanicLeaves() {
    let successMessage = this.translate.instant("lblMechanicLeaveAddedSuccessfully");
    let errorMessage = this.translate.instant("lblErrorMessage");
    let invalidIdErrorMessage = this.translate.instant("lblInvalidMechanicId");
    let startDateRequiredMessage = this.translate.instant("lblStartDateisrequired");
    let endDateRequiredMessage = this.translate.instant("lblEndDateisrequired");
    let endDateGreaterOrEqualToStartDateMessage = this.translate.instant("lblEndDateGreaterOrEqualToStartDate");
    let provideRemrk=this.translate.instant("lblPleaseProvideRemark");
    if(this.mechanicLeaves.remark===null ||this.mechanicLeaves.remark==='')
    {
      this.spinner.hide();
      this.toaster.error(provideRemrk);
      return;
    }
    if (this.mechanicLeaves.multiDateList?.length <=0 && this.mechanicLeaves.startDate == null) {
      this.spinner.hide();
      this.toaster.error(startDateRequiredMessage);
      return;
    }
    else if (this.mechanicLeaves.multiDateList?.length <=0 && this.mechanicLeaves.endDate == null) {
      this.spinner.hide();
      this.toaster.error(endDateRequiredMessage);
      return;
    }
    else if(this.mechanicLeaves.leaveType===Enums.LeaveType.Recurring && (this.mechanicLeaves.recurring <= 0 || this.mechanicLeaves.recurring>99))
    {
      this.spinner.hide();
      let errorMessage = this.translate.instant("lblEnterValidRecurringBetween0to99");
      this.toaster.error(errorMessage);
      return;
    }
    else if(this.mechanicLeaves.leaveType===Enums.LeaveType.Recurring && (this.mechanicLeaves.selectedDays ===null || this.mechanicLeaves.selectedDays===''))
    {
      this.spinner.hide();
      let errorMessage = this.translate.instant("lblSelectWeekDays");
      this.toaster.error(errorMessage);
      return;
    }
    else {
      let localStartDate;let localEndDate;
      if(this.mechanicLeaves.multiDateList <=0){
        localStartDate = Utility.getDateStringToDate(this.mechanicLeaves?.startDate?.split(' ')[0]);
        localStartDate.setHours(this.mechanicLeaves?.startDate?.split(' ')[1]?.split(':')[0]);
        localStartDate.setMinutes(this.mechanicLeaves?.startDate?.split(' ')[1]?.split(':')[1]);

        localEndDate = Utility.getDateStringToDate(this.mechanicLeaves?.endDate?.split(' ')[0]);
        localEndDate.setHours(this.mechanicLeaves?.endDate?.split(' ')[1]?.split(':')[0]);
        localEndDate.setMinutes(this.mechanicLeaves?.endDate?.split(' ')[1]?.split(':')[1]);
        if(localStartDate >= localEndDate && this.mechanicLeaves.leaveType === Enums.LeaveType.DateRange){
          this.spinner.hide();
          this.toaster.error(endDateGreaterOrEqualToStartDateMessage);
          return;
        }
        if((new Date(localStartDate?.getFullYear(),localStartDate?.getMonth(),localStartDate?.getDate()) > new Date(localEndDate?.getFullYear(),localEndDate?.getMonth(),localEndDate?.getDate())) && this.mechanicLeaves.leaveType === Enums.LeaveType.Recurring){
          this.spinner.hide();
          this.toaster.error(endDateGreaterOrEqualToStartDateMessage);
          return;
        }
        
      }

      if(this.mechanicLeaves.leaveType===Enums.LeaveType.Recurring && this.mechanicLeaves.selectedDays!==null && this.mechanicLeaves.selectedDays!=='')
      {
        this.mechanicLeaves.selectedDays= this.mechanicLeaves.selectedDays.replace(/^,*$/, '');
      }

      let viewModel = {
        dealerId: this.dealerId,
        langCode: this.cookieservice.get('userSelectedLanguage'),
        mechanicHolidayViewModel: {...this.mechanicLeaves},
      }
      if(this.mechanicLeaves?.startDate && this.mechanicLeaves?.endDate){
        viewModel.mechanicHolidayViewModel.endDate = Utility.ConvertLocalDateToUTCDate(localEndDate);
        viewModel.mechanicHolidayViewModel.startDate = Utility.ConvertLocalDateToUTCDate(localStartDate);
      }
      if (this.mechanicLeaves.leaveType===Enums.LeaveType.Recurring && (
        (localStartDate?.getHours() > localEndDate?.getHours())
         || ((localStartDate?.getHours() == localEndDate?.getHours()) && (localStartDate?.getMinutes() > localEndDate?.getMinutes()))
      || (localStartDate?.getHours() == localEndDate?.getHours() && localStartDate?.getMinutes() == localEndDate?.getMinutes())
      )) {
        this.spinner.hide();
        let errorMsg = this.translate.instant("lblEndtimeShouldBeGreaterThanStartTime");
        this.toaster.error(errorMsg);
        return;
      }
      this.service.AddMechanicLeaves(viewModel).then(res => {
        if (res.responseCode === Constant.SuccessResponseCode) {
          if(!(res?.responseObject?.isValid) && (res?.responseObject?.errorCode === Constant.MechanicLeaveAlreadyExists)){
            let errorMsg = this.translate.instant("lblLeaveAlreadyExists");
            this.toaster.error(errorMsg)
          }
          else if(!(res?.responseObject?.isValid) && (res?.responseObject?.errorCode === Constant.NoMechanicLeaveExists)){
            let errorMsg = this.translate.instant("lblNoLeaveExists");
            this.toaster.error(errorMsg)
          }
          else if(!(res?.responseObject?.isValid)){
            let errorMsg = this.translate.instant("lblDealerIsOnLeave");
            this.toaster.error(errorMsg)
          }
          else if(res?.responseObject?.errorCode === Constant.MechanicPlanned){
            let errorMsg = this.translate.instant("lblMechanicPlanned");
            this.toaster.warning(errorMsg)
          }

          else{
            localStorage.setItem('lastMechanic', JSON.stringify(this.mechanicLeaves));
            this.toaster.success(successMessage);
            this.addMechanicLeave = false;
            this.ngOnInit();
          }
        }
        else if (res.responseCode === Enums.ErrorCodes.InvalidMechanicId) {
          this.spinner.hide();
          this.toaster.warning(invalidIdErrorMessage);
        }
      }, _error => {
        this.spinner.hide();
        this.toaster.error(errorMessage);
      });
    }
  }

  private async GetMechanicLeavebyId(Id: number,MechanicLeaveRecurringId:number) {
    this.spinner.show();
    await this.service.GetMechanicLeavebyId(Id,MechanicLeaveRecurringId).then(result => {
      if (result.responseCode === Enums.ErrorCodes.SuccessCode) {
        this.mechanicLeaves = result.responseObject;
        this.mechanicLeaves.startDate = this.mechanicLeaves.startDate? Utility.GetFormattedDateTime(Utility.ConvertUTCDateToLocalDate(this.mechanicLeaves.startDate)):null;
        this.mechanicLeaves.endDate = this.mechanicLeaves.endDate? Utility.GetFormattedDateTime(Utility.ConvertUTCDateToLocalDate(this.mechanicLeaves.endDate)):null;
        let days = this.mechanicLeaves.selectedDays?.split(',');
        if(days?.length > 0 )  {
          days.forEach(element => {
            this.weekDays[+element].isSelected = true;
          });
        }
      }
      else if (result.responseObject.result && result.responseObject.result.errorCode === Enums.ErrorCodes.NotFound) {
        let errorMessage = this.translate.instant("lblNotFound");
        this.toaster.error(errorMessage);
      }
      else if (result.responseCode === Enums.ErrorCodes.InvalidIdCode) {
        let invalidIdErrorMessage = this.translate.instant("lblInvalidMechanicId");
        this.toaster.error(invalidIdErrorMessage);
      }
      this.spinner.hide();
    },
    _error => {
        this.spinner.hide()
      });
  }

  GetClassFromDate(dateString: any){
    let date: Date;
    if(dateString){
      date = Utility.getDateStringToDate(dateString?.split(' ')[0]);
      date.setHours(dateString?.split(' ')[1]?.split(':')[0]);
      date.setMinutes(dateString?.split(' ')[1]?.split(':')[1]);
      if(date <= new Date()){
        return 'disable';
      }
    }
  }


  EditMechanicLeaves() {
    let successMessage = this.translate.instant("lblMechanicLeavesDetailsAreEdited");
    let errorMessage = this.translate.instant("lblMechanicLeavesDetailsAreNotEdited");
    let startDateRequiredMessage = this.translate.instant("lblStartDateisrequired");
    let endDateRequiredMessage = this.translate.instant("lblEndDateisrequired");
    let endDateGreaterOrEqualToStartDateMessage = this.translate.instant("lblEndDateGreaterOrEqualToStartDate");
    this.spinner.show();
    let provideRemrk=this.translate.instant("lblPleaseProvideRemark");
    if(this.mechanicLeaves.remark===null ||this.mechanicLeaves.remark==='')
    {
      this.spinner.hide();
      this.toaster.error(provideRemrk);
      return;
    }
    if (this.mechanicLeaves.multiDateList?.length <=0 && this.mechanicLeaves.startDate == null) {
      this.spinner.hide();
      this.toaster.error(startDateRequiredMessage);
        return;
    }
    else if (this.mechanicLeaves.multiDateList?.length <=0 && this.mechanicLeaves.endDate == null) {
      this.spinner.hide();
      this.toaster.error(endDateRequiredMessage);
      return;
    }
    else if(this.mechanicLeaves.leaveType===Enums.LeaveType.Recurring && (this.mechanicLeaves.recurring <= 0 || this.mechanicLeaves.recurring>99))
    {
      this.spinner.hide();
      let errorMessage = this.translate.instant("lblEnterValidRecurringBetween0to99");
      this.toaster.error(errorMessage);
      return;
    }
    else if(this.mechanicLeaves.leaveType===Enums.LeaveType.Recurring && (this.mechanicLeaves.selectedDays ===null || this.mechanicLeaves.selectedDays===''))
    {
      this.spinner.hide();
      let errorMessage = this.translate.instant("lblSelectWeekDays");
      this.toaster.error(errorMessage);
      return;
    }

    else {
      let localStartDate;let localEndDate;
      if(this.mechanicLeaves.multiDateList <=0){
        localStartDate = Utility.getDateStringToDate(this.mechanicLeaves?.startDate?.split(' ')[0]);
        localStartDate.setHours(this.mechanicLeaves?.startDate?.split(' ')[1]?.split(':')[0]);
        localStartDate.setMinutes(this.mechanicLeaves?.startDate?.split(' ')[1]?.split(':')[1]);

        localEndDate = Utility.getDateStringToDate(this.mechanicLeaves?.endDate?.split(' ')[0]);
        localEndDate.setHours(this.mechanicLeaves?.endDate?.split(' ')[1]?.split(':')[0]);
        localEndDate.setMinutes(this.mechanicLeaves?.endDate?.split(' ')[1]?.split(':')[1]);
        if(localStartDate >= localEndDate && this.mechanicLeaves.leaveType === Enums.LeaveType.DateRange){
          this.spinner.hide();
          this.toaster.error(endDateGreaterOrEqualToStartDateMessage);
          return;
        }
        if((new Date(localStartDate?.getFullYear(),localStartDate?.getMonth(),localStartDate?.getDate()) > new Date(localEndDate?.getFullYear(),localEndDate?.getMonth(),localEndDate?.getDate())) && this.mechanicLeaves.leaveType === Enums.LeaveType.Recurring){
          this.spinner.hide();
          this.toaster.error(endDateGreaterOrEqualToStartDateMessage);
          return;
        }
        if(this.mechanicLeaves.leaveType === Enums.LeaveType.Recurring){
          let yestDate = new Date();
          yestDate.setDate(new Date().getDate() - 1);
          // if(localEndDate < yestDate){
          //   this.spinner.hide();
          //   let errorMessage = this.translate.instant("lblLeaveAlreadyStarted");
          //   this.toaster.error(errorMessage);
          //   return;
          // }
        }
      }
      if(this.mechanicLeaves.leaveType===Enums.LeaveType.Recurring && this.mechanicLeaves.selectedDays!==null && this.mechanicLeaves.selectedDays!=='')
      {
        this.mechanicLeaves.selectedDays= this.mechanicLeaves.selectedDays.replace(/^,*$/, '');
      }
      this.mechanicLeaves.multiDateList = [];
    let viewModel =
    {
      dealerId: this.dealerId,
      langCode: this.cookieservice.get('userSelectedLanguage'),
      MechanicHolidayViewModel: {...this.mechanicLeaves}
    }
    if(this.mechanicLeaves?.startDate && this.mechanicLeaves?.endDate){
      viewModel.MechanicHolidayViewModel.endDate = Utility.ConvertLocalDateToUTCDate(localEndDate);
      viewModel.MechanicHolidayViewModel.startDate = Utility.ConvertLocalDateToUTCDate(localStartDate);
    }
    if (this.mechanicLeaves.leaveType===Enums.LeaveType.Recurring && (
      (localStartDate?.getHours() > localEndDate?.getHours())
       || ((localStartDate?.getHours() == localEndDate?.getHours()) && (localStartDate?.getMinutes() > localEndDate?.getMinutes()))
    || (localStartDate?.getHours() == localEndDate?.getHours() && localStartDate?.getMinutes() == localEndDate?.getMinutes())
    )) {
      this.spinner.hide();
      let errorMsg = this.translate.instant("lblEndtimeShouldBeGreaterThanStartTime");
      this.toaster.error(errorMsg);
      return;
    }

    this.service.UpdateMechanicLeaves(viewModel).then(res => {

      if (res.responseCode === Constant.SuccessResponseCode) {
        if(!(res?.responseObject?.isValid) && (res?.responseObject?.errorCode === Constant.MechanicLeaveAlreadyExists)){
          let errorMsg = this.translate.instant("lblLeaveAlreadyExists");
          this.toaster.error(errorMsg)
        }
        else if(!(res?.responseObject?.isValid) && (res?.responseObject?.errorCode === Constant.NoMechanicLeaveExists)){
          let errorMsg = this.translate.instant("lblNoLeaveExists");
          this.toaster.error(errorMsg)
        }
        else if(!(res?.responseObject?.isValid)){
          let errorMsg = this.translate.instant("lblDealerIsOnLeave");
          this.toaster.error(errorMsg)
        }
        else if(res?.responseObject?.errorCode === Constant.MechanicPlanned){
          let errorMsg = this.translate.instant("lblMechanicPlanned");
          this.toaster.warning(errorMsg)
        }
        else{
          localStorage.setItem('lastMechanic', JSON.stringify(this.mechanicLeaves));
          this.toaster.success(successMessage);
          this.editMechanicLeave = false;
        this.ngOnInit();
        }
        this.spinner.hide();
      }
      else {
        this.spinner.hide();
        this.toaster.error(errorMessage);
      }
    }, _error => {
      this.spinner.hide();
      this.toaster.error(errorMessage);
    });
  }
}


  DeleteLeave(id: number) {

    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"),this.translate.instant("lblLeaves"),true);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
     }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.service.DeleteLeave(id).then((response) => {
          if (response.responseCode == Constant.SuccessResponseCode) {
            let deletedmsg = this.translate.instant("lblDeleted");
            this.toaster.success(deletedmsg)
            this.ngOnInit();
          }
        });
      }
    });
  }

  private MechanicLeavesDataMapper(List: any) {
    let supperArray = [];
    if (List && List.length > 0) {
      List.forEach((element,index)=>{
        let single = Object();
        single.rowNumber = this.currentPageNumber(index);
        single.id = element.id;
        single.endDate = element.endDate ? new Date(element.endDate + 'Z') : null;
        single.startDate = element.startDate ? new Date(element.startDate + 'Z') : null;
        single.isStartDateEditable = new Date(single.startDate) >= new Date();
        single.isEndDateEditable = new Date(single.endDate) >= new Date();
        single.optionId=element.option;
        single.option = this.GetLeaveOptionType(element.option);
        single.leaveType = this.GetLeaveType(element.leaveType);
        single.leaveTypeId=element.leaveType;
        single.remark = element.remark;
        single.selectedDays = element.selectedDays?this.GetWeekDays(element.selectedDays):'-';
        single.absenceHour = element.absenceHour;
        single.mechanicLeaveRecurringId = element.mechanicLeaveRecurringId;
        single.dmsLeaveId = element.dmsLeaveId;
        supperArray.push(single);
      })
    }
    return supperArray;
  }

  GetLeaveOptionType(option: number){
    if (this.isLeaveTypeHidden) {
      switch (option) {
        case Enums.CustomLeaveOptionType.Sykemelding:
          return 'Sykemelding';
        case Enums.CustomLeaveOptionType.Egenmelding:
          return 'Egenmelding';
        case Enums.CustomLeaveOptionType.Kurstrening:
          return 'Kurs\trening';
        case Enums.CustomLeaveOptionType.Ferie:
          return 'Ferie';
        case Enums.CustomLeaveOptionType.Permisjon:
          return 'Permisjon';
        default:
          return '';
      }
    } else {
      switch (option) {
        case Enums.LeaveOptionType.Personal:
          return 'lblPersonal';
        case Enums.LeaveOptionType.Business:
          return 'lblBusiness';
        case Enums.LeaveOptionType.Vacation:
          return 'lblVacation';
        case Enums.LeaveOptionType.Sick:
          return 'lblSick';
        case Enums.LeaveOptionType.Course:
          return 'lblCourse';
        case Enums.LeaveOptionType.Other:
          return 'lblOther';
        default:
          return '';
      }
    }
  }

  GetLeaveType(leaveType:number){
    switch (leaveType) {
      case Enums.LeaveType.DateRange:
        return 'DateRange';
      case Enums.LeaveType.MultiDay:
        return 'MultiDay';
        case Enums.LeaveType.Recurring:
          return 'Recurring';
      default:
        return '';
    }
  }

  GetWeekDays(selectedDays:string){
      let outputArray = [];
      selectedDays.split(',').forEach(element => {
        switch (+element) {
          case Enums.WeekDays.Sunday:
            outputArray.push('Sunday');
            break;
          case Enums.WeekDays.Monday:
            outputArray.push('Monday');
            break;
          case Enums.WeekDays.Tuesday:
            outputArray.push('Tuesday');
            break;
          case Enums.WeekDays.Wednesday:
            outputArray.push('Wednesday');
            break;
          case Enums.WeekDays.Thursday:
            outputArray.push('Thursday');
            break;
          case Enums.WeekDays.Friday:
            outputArray.push('Friday');
            break;
          case Enums.WeekDays.Saturday:
            outputArray.push('Saturday');
            break;
          default:
            outputArray.push('');
        }
      });
      return outputArray.join(',');
  }

  private currentPageNumber(cIndex: number): number {
    let rtPageNumber = 0;
    if (this.pService.page === 1) {
      rtPageNumber = cIndex + 1;
    }
    else if (this.pService.page > 1) {
      rtPageNumber = Number.parseInt(`${(this.pService.pageSize * (this.pService.page - 1))}`) + (cIndex + 1);
    }

    return rtPageNumber;
  }

  onEdit(leave: any) {
    this.editMechanicLeave = true;
    this.mechanicLeavesDetails = false;
    this.leaveId = leave.id;
    this.GetMechanicLeavebyId(this.leaveId,leave.mechanicLeaveRecurringId);
  }

  onDelete(leave: any) {
    this.secureStorage.setKeyData('LeaveId', leave.id);
  }

  onAdd() {
    //make model empty
    this.mechanicLeaves =
    {
      id: null,
      mechanicId: null,
      startDate: null,
      endDate: null,
      startDateTime: null,
      endDateTime: null,
      option:1,
      leaveType:1,
      recurring:1,
      remark:null,
      selectedDays:'',
      absenceHour:'',
      mechanicLeaveRecurringId:null,
      multiDateList:[],
      dmsLeaveId:''
    };
    this.addMechanicLeave = true;
    this.mechanicLeaves.mechanicId = this.id;
    this.mechanicLeaves.startDate = null;
    this.mechanicLeaves.endDate = null;
    this.dealerId = this.service.dealerId;
    this.mechanicLeavesDetails = false;
  }

  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  OnClose() {
    this.activeModal.close({ success: true });
    this.editMechanicLeave = false;
  }

  LeaveTypeChange(){
    this.weekDays = [
      { id: 0, name: 'SUN' ,isSelected:false},
      { id: 1, name: 'MON' ,isSelected:false},
      { id: 2, name: 'TUE' ,isSelected:false},
      { id: 3, name: 'WED' ,isSelected:false},
      { id: 4, name: 'THU' ,isSelected:false},
      { id: 5, name: 'FRI',isSelected:false },
      { id: 6, name: 'SAT' ,isSelected:false}
    ];
    this.mechanicLeaves.startDate= null;
    this.mechanicLeaves.endDate = null;
    this.mechanicLeaves.startDateTime = null;
    this.mechanicLeaves.endDateTime = null;
    this.mechanicLeaves.remark = null;
    this.mechanicLeaves.selectedDays = '';
    this.mechanicLeaves.absenceHour = '';
    this.mechanicLeaves.mechanicLeaveRecurringId = null;
    this.mechanicLeaves.multiDateList = [];
  }

  checkRecurring()
  {
    if(this.mechanicLeaves.recurring < 1 || this.mechanicLeaves.recurring > 99)
    {
      let errorMessage = this.translate.instant("lblEnterValidRecurringBetween0to99");
      this.toaster.error(errorMessage);
        return;  
    }
  }
  OnDateChanged(event)
  {
    let model={
      startDate:new Date(event+'Z'),
      endDate:new Date(event+'Z')
    }
    let isAlreadyExists=false;
    this.mechanicLeaves.multiDateList.forEach(element => {
      model.startDate.setHours(0, 0, 0, 0)
      model.endDate.setHours(23, 59, 0, 0);
      if((new Date(element.endDate).toDateString()===model.startDate.toDateString()))
        isAlreadyExists=true;
    });
    if(!isAlreadyExists){
      let dateString={
        startDate:null,
        endDate:null
      }
      model.startDate.setHours(0, 0, 0, 0)
      model.endDate.setHours(23, 59, 0, 0);
      dateString.startDate = Utility.ConvertLocalDateToUTCDate(model.startDate)
      dateString.endDate = Utility.ConvertLocalDateToUTCDate(model.endDate)
        this.mechanicLeaves.multiDateList.push(dateString)
    }
  }

  DeleteMultiDateLeave(leave,i)
  {
    this.mechanicLeaves.multiDateList.splice(i,1);
  }

  async GetMechanicLeaveTypes(){
    await this.service.GetMechanicLeaveTypes().then((response:any)=>{
      if(response.responseCode === Constant.SuccessResponseCode){
        this.mechanicLeaveTypesList = response.responseObject;
        this.mechanicLeaveTypesList = this.mechanicLeaveTypesList.filter(x=>!x.isDeleted);
      }
    })
  }
}
